import { clearApiKey } from "@tc/ui-typesense-client"

/** Session storage key for dismissed announcement banner state */
export const ANNOUNCEMENT_DISMISSED_KEY = "dismissed-announcement-banner"

/** Session storage key for the requests page filter state */
export const REQUESTS_FILTER_STATE_KEY = "requestsFilterState"

/**
 * Perform all session cleanup before signing out.
 * Centralizes cleanup to avoid duplication across signOut wrappers.
 */
export const signOutCleanup = (): void => {
  clearApiKey()
  sessionStorage.removeItem(ANNOUNCEMENT_DISMISSED_KEY)
  sessionStorage.removeItem(REQUESTS_FILTER_STATE_KEY)
}
